<template>
    <div>
        <div class="row">
            <div class="col-md-6 d-md-flex align-items-baseline">
                <h1 class="mr-2">List of Addresses</h1>
            </div>
            <!-- SEARCH FUNCTION HERE -->
            <div class="col-md-6 pb-3">
                <input-search-icon
                    v-model="filter.search"
                    @search="searchAddress"
                    :placeholder="'Search Address'"
                    :haveItemOnRightSide="true"
                >
                    <template v-slot:after>
                        <button
                            type="button"
                            class="btn btn-secondary ml-1"
                            v-b-tooltip.hover.top
                            title="New Address"
                            @click="configAddress(null, 'Create')"
                            v-if="_hasAccess('setting.address.add')"
                        >
                            <span class="fas fa-plus"></span>
                        </button>
                    </template>
                </input-search-icon>
            </div>
        </div>
        <div class="card rounded-lg p-3">
            <div class="card-body overflow-auto p-0">
                <div class="table-holder table-responsive">
                    <LoaderList v-if="isLoading" class="w-100" />
                    <table v-else class="table list">
                        <thead>
                            <tr>
                                <th>
                                    <sorting
                                        :order-by="
                                            filter && filter.sortName
                                                ? filter.sortName
                                                : null
                                        "
                                        @sorting="
                                            orderBy =>
                                                sortingData(orderBy, 'name')
                                        "
                                        text="Name:"
                                    >
                                    </sorting>
                                </th>
                                <th>
                                    <sorting
                                        :order-by="
                                            filter && filter.sortAddress
                                                ? filter.sortAddress
                                                : null
                                        "
                                        @sorting="
                                            orderBy =>
                                                sortingData(orderBy, 'address')
                                        "
                                        text="Address:"
                                    >
                                    </sorting>
                                </th>
                                <th>Postal Code:</th>
                                <th>City:</th>
                                <th>County:</th>
                                <th>State:</th>
                                <th>Country:</th>
                                <th>Primary:</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody v-if="addressList">
                            <template v-for="address in addressList">
                                <tr :key="'row-' + address.id">
                                    <td>{{ address.name }}</td>
                                    <td>{{ address.address }}</td>
                                    <td>{{ address.zipcode }}</td>
                                    <td>{{ address.city }}</td>
                                    <td>{{ address.county }}</td>
                                    <td>{{ address.state }}</td>
                                    <td>{{ address.country }}</td>
                                    <td>
                                        {{ address.is_primary ? "Yes" : "No" }}
                                    </td>
                                    <td class="text-right small text-nowrap">
                                        <spinner
                                            v-if="address.isLoading"
                                        ></spinner>
                                        <div v-else>
                                            <span
                                                style="cursor: pointer;"
                                                @click="
                                                    configAddress(
                                                        address,
                                                        'Update'
                                                    )
                                                "
                                                v-if="
                                                    _hasAccess(
                                                        'setting.address.edit'
                                                    )
                                                "
                                            >
                                                Edit
                                            </span>
                                            <span
                                                v-if="
                                                    _hasAccess(
                                                        'setting.address.edit'
                                                    ) &&
                                                    _hasAccess(
                                                        'setting.address.delete'
                                                    )
                                                "
                                                >|</span
                                            >
                                            <span
                                                style="cursor: pointer;"
                                                @click="
                                                    configAddress(
                                                        address,
                                                        'Delete'
                                                    )
                                                "
                                                v-if="
                                                    _hasAccess(
                                                        'setting.address.delete'
                                                    )
                                                "
                                            >
                                                Delete
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                        <tbody v-if="addressList.length == 0">
                            <tr>
                                <td :colspan="9">
                                    <i>No records available</i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <pagination
                :current-page="filter.page"
                :totalPages="totalPages"
                :isLoading="isLoading"
                @change-page="page => changePage(page)"
            />
        </div>
        <modal-config-address ref="configAddressModal" />
    </div>
</template>
<script>
import addressService from "@/services/address";

export default {
    components: {
        LoaderList: () => import("@/components/elements/loader-list.vue"),
        Sorting: () => import("@/module/commons/sorting.vue"),
        Pagination: () => import("@/components/commons/pagination.vue"),
        inputSearchIcon: () => import("@/module/commons/input-search-icon.vue"),
        Spinner: () => import("@/components/elements/spinner.vue"),
        ModalConfigAddress: () =>
            import("@/components/setting-address/modal-config-address.vue")
    },
    data() {
        return {
            isLoading: true,
            filter: {
                search: "",
                sortName: "",
                sortAddress: "",
                perPage: 20,
                page: 1
            },
            totalPages: 0,
            addressList: []
        };
    },
    computed: {
        refresh() {
            return this.$store.getters["address/refresh"];
        }
    },
    async created() {
        this.getAddress();
    },
    watch: {
        filter: {
            handler() {
                this.getAddress();
            },
            deep: true
        },
        refresh() {
            this.getAddress();
        }
    },
    methods: {
        async getAddress() {
            this.isLoading = true;
            const res = await addressService.getAddressList(this.filter);
            const { meta, data } = res.data.response.resource;
            if (res.status == 200) {
                this.addressList = data;
                this.totalPages = meta.lastPage;
            }
            this.isLoading = false;
        },
        sortingData(orderBy, col) {
            this.filter.page = 1;
            if (col == "name") {
                this.filter.sortName = orderBy;
                this.filter.sortAddress = "";
            } else if (col == "address") {
                this.filter.sortName = "";
                this.filter.sortAddress = orderBy;
            }
        },
        changePage(page) {
            this.filter.page = page;
        },
        searchAddress(keyword) {
            this.filter.search = keyword;
            this.resetFilter();
        },
        resetFilter() {
            this.filter.sortAddress = "";
            this.filter.sortName = "";
            this.filter.page = 1;
        },
        configAddress(data, type) {
            let address = null;
            if (type != "Create") {
                address = JSON.parse(JSON.stringify(data));
            }

            this.$refs.configAddressModal.open(type, address);
        }
    }
};
</script>
